import React from 'react';

import { DataGrid, DataGridProps, useDateTimeFormatSetting, useNumberFormatSetting } from '@fides/fides-react-components';
export const DLCDataGrid = (props: DataGridProps) => {
  const { gridOptions, columnDefs, gridId, ...restProps } = props;
  const dateTimeFormat = useDateTimeFormatSetting();
  const numberFormatSetting = useNumberFormatSetting();

  const defaultColDef = {
    filter: 'agTextColumnFilter',
    filterParams: { filterOptions: ['contains'], suppressAndOrCondition: true },
    flex: undefined,
  };

  return (
    <DataGrid
      gridId={gridId}
      sideBar={props.hasOwnProperty('sideBar') ? props.sideBar : true}
      numberFormat={numberFormatSetting.locale}
      dateTimeFormat={dateTimeFormat}
      advancedFilters
      {...restProps}
      defaultColDef={defaultColDef}
      columnDefs={columnDefs}
      gridOptions={{ 
		getRowId: (params: any) => params.data.uuid, 
      	rowModelType: "serverSide", serverSideStoreType: 'partial', ...gridOptions, }}
      autoSaveGridConfiguration
    />
  );
};